import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { initializeCenterContent } from "redux/reducers/contentReducer";
import ContentManagement from "./ContentManagement";

const DisplayContentManagement = () => {
  const selectedCenterId = useSelector(({ center }) => center)?.data?.id
  const contents = useSelector(({ content }) => content);

  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedCenterId && contents.data?.length === 0) {
      dispatch(initializeCenterContent(selectedCenterId));
    }
  }, [selectedCenterId, dispatch]);

  return (
    <Box mt={4} sx={{ minWidth: "100%" }}>
      {selectedCenterId && (
        <ContentManagement entityId={selectedCenterId} contents={contents} />
      )}
    </Box>
  );
};

export default DisplayContentManagement;
